
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { getFindAreaList } from "@/api/api-basic";
import { listToTree } from "@/common/tree";
@Component
export default class PiSelectCity extends Vue {
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: "" }) private placeholder!: string; // 修正默认值为空字符串
  @Model("value", { type: Array }) private modelVlaue!: string[];
  @Watch("modelVlaue")
  getVisible() {
    this.modelArr = this.modelVlaue;
  }
  private dataList: object[] = [];
  private modelArr: string[] = [];

  async loadData(): Promise<void> {
    const ret = await getFindAreaList({});
    if (ret.status === this.$config.apiStatus) {
      let data = ret.data || [];
      data = data.map((item: any) => {
        return {
          value: item.pkid + "",
          label: item.name,
          pid: item.parentId + "",
          zipCode: item.zipCode
        };
      });
      this.dataList = listToTree(data, { id: "value" });
    }
  }

  public cityChange(value: string[]) {
    this.modelArr = value;
    this.$emit("value", value);
    this.$emit("on-change", value);
  }

  mounted() {
    this.modelArr = this.modelVlaue || [];
    this.loadData();
  }
}
